import React from 'react'

import { SpinnerWithTitle } from 'src/features/SpinnerWithTitle'
import { useScopedTranslation } from 'src/shared/hooks/useScopedTranslation'

export function LoadingResults() {
  const t = useScopedTranslation('translation.medications.drug_search.status')
  return <SpinnerWithTitle text={t('searching')} />
}
